import React from 'react';
import { useNavigate } from 'react-router-dom';
import { createContactNavigationHandler } from '../../../utils/contactNavigation';

import {
  ButtonsContainer,
  ContactRow,
  ContactButton,
  ContactAvatar,
  PanelHeader,
} from './ContactButtonsPanel.styles';

function ContactButtonsPanel() {
  const navigate = useNavigate();
  const handleContactClick = createContactNavigationHandler(navigate);
  return (
    <ButtonsContainer direction="column" spacing={1}>
      <PanelHeader>Find me here</PanelHeader>
      <ContactRow>
        <ContactButton
          variant="text"
          disabled
          aria-label="Location: Remote & Roaming"
        >
          <ContactAvatar alt="" src="location-icon.png" aria-hidden="true" />
          Remote & Roaming (Based in FL)
        </ContactButton>
      </ContactRow>
      <ContactRow>
        <ContactButton
          variant="text"
          component="button"
          onClick={handleContactClick}
          aria-label="Email Hadley Swello"
        >
          <ContactAvatar alt="" src="email-icon.png" aria-hidden="true" />
          Email Me
        </ContactButton>
      </ContactRow>
      <ContactRow>
        <ContactButton
          target="_blank"
          rel="noopener"
          variant="text"
          href="https://www.linkedin.com/in/hadleyswello/"
          aria-label="Hadley Swello on LinkedIn"
        >
          <ContactAvatar
            alt=""
            src="linkedin-icon.png"
            variant="square"
            aria-hidden="true"
          />
          LinkedIn
        </ContactButton>
      </ContactRow>
      <ContactRow>
        <ContactButton
          target="_blank"
          rel="noopener"
          variant="text"
          href="https://github.com/HadleySwello"
          aria-label="Hadley Swello on GitHub"
        >
          <ContactAvatar
            alt=""
            src="github-logo.svg"
            variant="square"
            aria-hidden="true"
          />
          GitHub
        </ContactButton>
      </ContactRow>
    </ButtonsContainer>
  );
}

export default ContactButtonsPanel;
